module.exports = __webpack_public_path__ + "img/Bootfahren.59277068.svg";